<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    openPopup() {
      this.togglePopup('order-call-with-message');
      this.addTitlePopup('<span>Подать</span> заявку на выкуп');
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row 2xl:my-20">
        <div class="relative hidden xl:block w-full lg:w-1/2">
          <div class="static lg:absolute top-0 right-0 w-full lg:w-[calc(100%+(100vw-990px)/2)] xl:w-[calc(100%+(100vw-1140px)/2)] 2xl:w-[calc(100%+(100vw-1220px)/2)] h-full flex items-center justify-center">
            <img
              class="w-full sm:w-10/12 lg:w-full max-w-[980px] h-auto"
              src="/public/images/pages/vikup/image-26.png"
              alt=""
            >
          </div>
        </div>

        <div class="w-full xl:w-[47%] ml-auto">
          <h2 class="title-h2 mb-6">Преимущества выкупа автомобиля в&nbsp;ПРАГМАТИКА Эксперт</h2>

          <div class="grid grid-cols-2 sm:grid-cols-3 gap-x-5 gap-y-5 mb-5">
            <div
              class="bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#advantages1"></use>
              </svg>
              <p class="text-sm text-gray-600">Вам не нужно тратить время и деньги на предпродажную подготовку</p>
            </div>

            <div
              class="bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#advantages2"></use>
              </svg>
              <p class="text-sm text-gray-600">Не нужно тратить время на общение с назойливыми покупателями и ездить к ним, показывая свой авто</p>
            </div>

            <div
              class="bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#advantages3"></use>
              </svg>
              <p class="text-sm text-gray-600">Мы высоко оценим ваш автомобиль</p>
            </div>

            <div
              class="row-start-4 row-end-5 sm:row-start-auto sm:row-end-auto col-start-1 col-end-3 bg-white p-4 rounded-big-brand -mt-5 sm:mt-0 cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#advantages4"></use>
              </svg>
              <p class="text-sm text-gray-600">Вы получите деньги сразу после оформления договора купли-продажи в удобной вам форме: наличными, на карту или в зачет другого автомобиля</p>
            </div>

            <div
              class="bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#advantages5"></use>
              </svg>
              <p class="text-sm text-gray-600">Мы гарантируем комфортные условия совершения сделки и юридическую чистоту</p>
            </div>
          </div>

          <div
            class="button button_green button_big w-full"
            @click="openPopup"
          >Подать заявку на выкуп</div>
        </div>
      </div>
    </div>
  </div>
</template>
